import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import selecionarPrestador from '../../actions/prestador/selecionarPrestador';


export class Prestador extends React.Component {
  selecionarPrestador(prestador) {
    this.props.changeFieldValue('formularioCadastrarPrestador', 'logradouro', prestador.logradouro);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'complemento', prestador.complemento);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'bairro', prestador.bairro);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'localidade', prestador.localidade);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'uf', prestador.uf);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'cep', prestador.cep);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'idPrestador', prestador.id);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'nome', prestador.nome);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'responsavel', prestador.responsavel);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'numero', prestador.numero);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'telefone', prestador.telefone);
    this.props.changeFieldValue('formularioCadastrarPrestador', 'cpfCnpj', prestador.cpfCnpj);
  }

  render() {
    const { prestador } = this.props;
    return (
      <div className="vx-gp-row">
        <div className="vx-gp-row-main vx-gp-row-main--prestador">
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Número</span>
            <span className="vx-gp-field-value">{prestador.id}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Nome</span>
            <span className="vx-gp-field-value">{prestador.nome}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Responsável</span>
            <span className="vx-gp-field-value">{prestador.responsavel}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">CPF/CNPJ</span>
            <span className="vx-gp-field-value">{prestador.cpfCnpj}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Telefone</span>
            <span className="vx-gp-field-value">{prestador.telefone}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Localidade</span>
            <span className="vx-gp-field-value">{prestador.localidade} - {prestador.uf}</span>
          </div>
          <div className="vx-gp-field">
            <div style={{ display: 'flex', gap: '6px' }}>
              <button
                type="button"
                className="vx-icon-btn"
                title="Editar"
                data-toggle="modal"
                data-target="#modalCadastrarPrestador"
                onClick={() => {
                  this.props.selecionarPrestador(prestador);
                  this.selecionarPrestador(prestador);
                }}
              >
                <i className="material-icons">edit</i>
              </button>
              <button
                type="button"
                className="vx-icon-btn vx-icon-btn--danger"
                title="Excluir"
                data-toggle="modal"
                data-target="#modalConfirmacaoExclusaoPrestador"
                onClick={() => this.props.selecionarPrestador(prestador)}
              >
                <i className="material-icons">delete</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps() {
  return {}
}

export default connect(mapStateToProps, {
  selecionarPrestador,
  changeFieldValue
})(Prestador)
